import { render, staticRenderFns } from "./questionAdmin.vue?vue&type=template&id=3dfc16cc&scoped=true&"
import script from "./questionAdmin.vue?vue&type=script&lang=js&"
export * from "./questionAdmin.vue?vue&type=script&lang=js&"
import style0 from "./questionAdmin.vue?vue&type=style&index=0&id=3dfc16cc&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfc16cc",
  null
  
)

export default component.exports